// export const PAYMENT_URL = 'http://wordpress-684254-4342059.cloudwaysapps.com';
export const PAYMENT_URL = "https://mebook.ai";
// export const API_URL = 'https://qa-api.mebook.ai/api';
export const API_URL = "https://api.mebook.ai/api";
// export const API_URL = "http://localhost:5001/api";
//  export const SOCKET_URL = 'https://qa-api.mebook.ai';
export const SOCKET_URL = "https://api.mebook.ai";
// export const SOCKET_URL = "http://localhost:5001";
